export default function BookingCTA() {
  return (
    <>
      {/* Final CTA Banner */}
      <section className="relative py-24 md:py-32 px-6 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/20bf0af9d652011fd5976364f453ff1b.jpg"
            alt="Studio"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/40" />
        </div>
        <div className="relative z-10 max-w-3xl mx-auto text-center">
          <span className="font-sans text-xs tracking-widest2 uppercase text-gold-light block mb-6">Ready?</span>
          <h2 className="font-serif text-4xl md:text-6xl text-white font-light leading-tight mb-6">
            Your Signature Nails<br /><em className="italic">Start Here</em>
          </h2>
          <div className="w-12 h-px bg-gold mx-auto mb-6" />
          <p className="font-sans text-sm md:text-base text-white/70 mb-10 tracking-wide">
            Book your custom set today
          </p>
          <a
            href="https://calendly.com/lispinruiz/nailappointment"
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap inline-block font-sans text-sm tracking-widest uppercase px-12 py-4 bg-gold text-white hover:bg-gold-dark transition-all duration-300 cursor-pointer"
          >
            Book Appointment
          </a>
        </div>
      </section>

      {/* Calendly Embed */}
      <section id="booking" className="bg-white py-24 md:py-32 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <span className="font-sans text-xs tracking-widest2 uppercase text-gold block mb-4">Appointments</span>
            <h2 className="font-serif text-4xl md:text-5xl text-ink font-light">Book Your Set</h2>
            <p className="font-sans text-sm text-ink-muted mt-4">Pick a time that works for you — it&apos;s that easy.</p>
          </div>

          <div className="w-full border border-blush-mid overflow-hidden" style={{ height: '700px' }}>
            <iframe
              src="https://calendly.com/lispinruiz/nailappointment"
              width="100%"
              height="100%"
              frameBorder="0"
              title="Book an appointment"
            />
          </div>
        </div>
      </section>
    </>
  );
}